import React, { Component } from 'react';
import { Container, Row, Col, Input, Table, Button, Alert, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import Session from '../auth/Session';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from './AdminFunctions';
import '../layout/site.css';

export class UserDetails extends Component {
    static displayName = UserDetails.name;

    constructor(props) {
        super(props);


        this.state = {
            user: {},
            userId: null,
            client: null,
            active: true,
            firstName: null,
            lastName: null,
            officePhone: null,
            ext: null,
            homePhone: null,
            mobilePhone: null,
            email: null,
            clientOptions: [],
            userLevel: null,
            address1: null,
            address2: null,
            state: null,
            zip: null,
            ticNo: null,
            Accounts: [],
            userLevels: ['TIC-MS Administrator', 'TIC-MS End User', 'Client Quality Administrator', 'Client End User', 'Client Accounting Services'],
            clientLevels: ['Client Quality Administrator', 'Client End User', 'Client Accounting Services'],
            success: undefined,
            message: '',
            userRole: '',
        };
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        const isAdmin = await AdminFunctions.isAdminAsync();
        const role = await AdminFunctions.getRoleNameAsync();

        console.log('Role: ' + role);

        if (role != null && role.length != 0) {
            this.setState({ userRole: role[0] });
        }

        if (!isAdmin && role != "Client Quality Administrator") {
            this.props.history.push('/accessdenied');
        }
        else {
            if (this.props.location.state !== undefined) {
                if (this.props.location.state.existingUser) {
                    const userId = this.props.location.state.userId;
                    this.setState({ userId: userId })
                    this.getUserDetails(userId);
                }
            }
            else {
                this.props.history.push('/admin/roles/create');
            }
        }
    }

    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row>
                        <Col>
                            <h3>User Details</h3>
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.ticNo}
                                onChange={(e) => this.setState({ ticNo: e.target.value })}
                                name='ticNo'
                                id='ticNo'
                                readOnly={this.state.userRole != 'TIC-MS Administrator'}
                                placeholder='TIC #'
                                style={{ display: this.state.userRole != 'TIC-MS Administrator' ? 'none' : '' }}
                            />
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col xs='6'>
                            <Typeahead
                                id='userLevel'
                                onChange={(selected) => this.setState({ userLevel: selected })}
                                selected={this.state.userLevel}
                                readOnly={this.state.userRole != "TIC-MS Administrator" && this.state.userRole != "Client Quality Administrator"}
                                options={this.state.userRole == "TIC-MS Administrator" ? this.state.userLevels : this.state.clientLevels}
                                placeholder='User Level'
                            />
                        </Col>
                        <Col xs='2' className='col-left-20'>
                            <Input
                                type='checkbox'
                                onChange={(e) => this.setState({ active: e.target.checked })}
                                checked={!!this.state.active}
                                name='active'
                            />
                            <label className='padding-10'>Active</label>
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                name='firstName'
                                id='firstName'
                                placeholder='First Name'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                name='lastName'
                                id='lastName'
                                placeholder='Last Name'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='email'
                                value={this.state.email}
                                onChange={(e) => this.setState({ email: e.target.value })}
                                name='email'
                                id='email'
                                placeholder='Email'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='4'>
                            <Input
                                type='tel'
                                value={this.state.mobilePhone}
                                onChange={(e) => this.setState({ mobilePhone: e.target.value })}
                                name='mobilePhone'
                                id='mobilePhone'
                                placeholder='Mobile Phone'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='4'>
                            <Input
                                type='tel'
                                value={this.state.homePhone}
                                onChange={(e) => this.setState({ homePhone: e.target.value })}
                                name='homePhone'
                                id='homePhone'
                                placeholder='Direct Line'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.address1}
                                onChange={(e) => this.setState({ address1: e.target.value })}
                                name='address1'
                                id='address1'
                                placeholder='Address 1'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.address2}
                                onChange={(e) => this.setState({ address2: e.target.value })}
                                name='address2'
                                id='address2'
                                placeholder='Address 2'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='6'>
                            <Input
                                type='text'
                                value={this.state.city}
                                onChange={(e) => this.setState({ city: e.target.value })}
                                name='city'
                                id='city'
                                placeholder='City'
                            />
                        </Col>
                    </Row>
                    <Row className='row-10'>
                        <Col xs='2'>
                            <Input
                                type='text'
                                length='2'
                                value={this.state.state}
                                onChange={(e) => this.setState({ state: e.target.value })}
                                name='state'
                                id='state'
                                placeholder='State'
                            />
                        </Col>
                        <Col xs='4'>
                            <Input
                                type='text'
                                value={this.state.zip}
                                onChange={(e) => this.setState({ zip: e.target.value })}
                                name='zip'
                                id='zip'
                                placeholder='Zip'
                            />
                        </Col>
                    </Row>
                    {(this.state.userId !== null && (this.state.userRole == 'TIC-MS Administrator' || this.state.userRole == 'Client Quality Administrator')) &&
                        <Row className='row-20'>
                            <Col>
                                <Button
                                    color='primary'
                                    onClick={() => this.handleResetPassword()}
                                >
                                    Send Password Reset Email
                                </Button>
                            </Col>
                        </Row>
                    }
                    <Row className='row-10'>
                        <Col xs='5'>
                            <Button
                                color='primary'
                                onClick={() => this.props.history.push('/admin/users')}
                            >
                                Back to Users
                            </Button>
                        </Col>
                        <Col xs='1'>
                            {(this.state.userRole == 'TIC-MS Administrator' || this.state.userRole == 'Client Quality Administrator') &&
                                <Button
                                    color='primary'
                                    onClick={() => this.handleSave()}
                                >
                                    Save
                                </Button>
                            }
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col>
                            {this.state.success === true && (
                                <Alert color='success'>
                                    {this.state.message}
                                </Alert>
                            )}
                            {this.state.success === false && (
                                <Alert color='danger'>
                                    {this.state.message}
                                </Alert>
                            )}
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    async getClientDropdown() {
        const token = Session.getToken();
        const response = await fetch(`api/Clients/GetDropdown`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ clientOptions: data });
    }

    async getUserDetails(userId) {
        const token = Session.getToken();
        const response = await fetch(`api/Admin/GetUserDetailsAsync?id=${userId}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            officePhone: data.officePhone,
            ext: data.ext,
            homePhone: data.homePhone,
            mobilePhone: data.mobilePhone,
            active: data.active,
            address1: data.address1,
            address2: data.address2,
            city: data.city,
            state: data.state,
            zip: data.zip,
            ticNo: data.ticNo,
            userLevel: data.userLevel == null ? null : [data.userLevel]
        });
    }

    async handleSave() {
        const token = Session.getToken();
        const dto = {
            id: this.state.userId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            officePhone: this.state.officePhone,
            ext: this.state.ext,
            homePhone: this.state.homePhone,
            mobilePhone: this.state.mobilePhone,
            active: this.state.active == null ? false : this.state.active,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city,
            state: this.state.state,
            zip: this.state.zip,
            ticNo: this.state.ticNo,
        }

        if (this.state.userLevel != null && this.state.userLevel != undefined) {
            dto.userLevel = this.state.userLevel.length != 0 ? this.state.userLevel[0] : '';
        }

        if (this.state.userId) {
            await this.editUser(dto, token);
        }
        else {
            await this.createUser(dto, token);
        }
    }

    async handleResetPassword() {
        const token = Session.getToken();
        const dto = {
            id: this.state.userId,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            officePhone: this.state.officePhone,
            ext: this.state.ext,
            homePhone: this.state.homePhone,
            mobilePhone: this.state.mobilePhone,
            active: this.state.active,
            address1: this.state.address1,
            address2: this.state.address2,
            city: this.state.city,
            state: this.state.state,
            zip: this.state.zip,
            ticNo: this.state.ticNo,
        }

        if (this.state.userLevel != null && this.state.userLevel != undefined) {
            dto.userLevel = this.state.userLevel.length != 0 ? this.state.userLevel[0] : '';
        }

        await this.sendResetEmail(dto, token);
    }

    async sendResetEmail(dto, token) {
        const response = await fetch('api/Admin/SendResetPasswordEmailAsync', {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();

        this.setState({ success: data, message: data == true ? 'The password reset email has been sent!' : 'Error sending password reset email!' });

        setTimeout(function () {
            this.setState({ success: undefined });
        }.bind(this), 5000);
    }

    async editUser(dto, token) {
        const response = await fetch('api/Admin/EditUserAsync', {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        this.setState({
            success: data,
            message: data == true ? "User updated successfully!" : "Error updating user!"
        });

        setTimeout(function () {
            this.setState({ success: undefined });
        }.bind(this), 5000);
    }

    async createUser(dto, token) {
        const response = await fetch('api/Admin/CreateUser', {
            method: 'POST',
            body: JSON.stringify(dto),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();

        if (data.id != null) {
            this.setState({
                userId: data.id,
                success: true,
                message: 'User added successfully!'
            });
        } else {
            this.setState({
                success: false,
                message: 'Error adding user!'
            });
        }

        setTimeout(function () {
            this.setState({ success: undefined });
        }.bind(this), 5000);
    }
}